<template>
	<!--<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">-->
	<sf-modal-layout size="l" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<sf-button size="sm" line icon="file" :onClick="ApprRsonAction"> {{ btnMsg }} </sf-button>
					<sf-button size="sm" line icon="circle-close" :onClick="close"> {{ getMessage_('MWCC000113') }} </sf-button>
				</div>
			</div>

			<div class="sf-table">
				<table class="">
					<tbody>
						<tr>
							<th>{{ labelMsg }}</th>
						</tr>
						<tr>
							<td><textarea class="excel-file__error__text addScroll" style="height: 380px; width: 860px" v-model="contents" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from './store/helpers';
import * as Yup from 'yup';
import { convertNvl, getHanBytes } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},

	data() {
		return {
			show: false,
			title: '',
			btnMsg: '',
			labelMsg: '',
			cfMsg: '',
			contents: '',
			apprState: '',
			apiType: '',
			masterKey1: '',
			masterKey2: '',
			masterKey3: '',
			masterKey4: '',
			masterKey5: '',
			notScheme: false,
			customSaveFn: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				contents: Yup.string()
					.test(
						'max',
						this.$sf_formatString(this.getMessage_('QWCC001739'), [this.labelMsg, '300', '800']), //은(는) 한글 300자 영문 800글자를 초과하며 입력할 수 없습니다.
						value => !(getHanBytes(value) > 300)
					)
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.labelMsg])) //{0}은(는) 팔수 입력 값 입니다.
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;

			this.title = param.title; //타이틀바
			this.btnMsg = param.btnMsg; //버튼
			this.labelMsg = param.labelMsg; //제목
			this.cfMsg = param.cfMsg; //반려혹은 기각시 컨펌메세지
			this.apprState = param.apprState; //처리상태코드
			this.apiType = param.apiType; //업무군값(PWA 또는 MQ 이런것들)
			this.masterKey1 = param.masterKey1; /*문서번호*/
			this.masterKey2 = param.masterKey2; /*마스터키1*/
			this.masterKey3 = param.masterKey3; /*마스터키2*/
			this.masterKey4 = param.masterKey4; /*마스터키3*/
			this.masterKey5 = param.masterKey5; /*마스터키4*/
			this.contents = '';
			if(param.notScheme){
				this.notScheme = param.notScheme;
			}
			this.customSaveFn = param.customSaveFn || null;

			//console.log('@@@@>>', param);
		},
		close() {
			//console.log('@@@@ popup close');
			// debugger;
			//this.setSearchParam_({ key: 'commCdType', value: null });
			//this.setSearchParam_({ key: 'commCdName', value: null });
			//this.setSearchParam_({ key: 'langCd', value: null });
			//console.log('ComCdPopup의 param', this.searchParams);

			//this.$refs.ComCdPopupSearch.reset();

			this.show = false;
		},
		async ApprRsonAction() {
			//셋팅함
			this.setStateApprInfoSave_({ key: 'apiType', value: convertNvl(this.apiType, '') }); // 업무구분값(각업무구분 )
			this.setStateApprInfoSave_({ key: 'masterKey1', value: convertNvl(this.masterKey1, '') }); // 키값1(pwa신청에서는 PWA번호가 키기 때문에 여기에 PWA번호가 셋팅됨)
			this.setStateApprInfoSave_({ key: 'masterKey2', value: convertNvl(this.masterKey2, '') }); // 키값2
			this.setStateApprInfoSave_({ key: 'masterKey3', value: convertNvl(this.masterKey3, '') }); // 키값3
			this.setStateApprInfoSave_({ key: 'masterKey4', value: convertNvl(this.masterKey4, '') }); // 키값4
			this.setStateApprInfoSave_({ key: 'masterKey5', value: convertNvl(this.masterKey5, '') }); // 키값5
			this.setStateApprInfoSave_({ key: 'contents', value: convertNvl(this.contents, '') }); // 사유
			this.setStateApprInfoSave_({ key: 'apprState', value: convertNvl(this.apprState, '') }); // 처리상태코드 (G기각,R)

			try {
				//console.log('saveApprReason>>>', this.saveApprReason);
				if(!this.notScheme){
					await this.schema.validateSync(this.saveApprReason);
				}
				

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.cfMsg, //기각하시게습니까 또는 반려하시겠니까 파라미터로 넘어옴
					buttons: [{ title: this.btnMsg, clickFn: () => this.apprRsonSave() }] //버튼 명도 파라마터로 넘어옴
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		apprRsonSave() {
			//console.log('@@@@ apprRsonSave start');

			if (this.customSaveFn) {
				this.close();
				this.customSaveFn(this.contents);
				return;
			}

			this.$sf_toggleLoading(true);
			this.saveApprReason_()
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}

					this.$sf_toggleLoading(true);
					this.close();
					this.$emit('apprRsonfresh');
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
